const TextWithSpace = new RegExp("^[ A-Z]+$", "i");
const TextEmail = new RegExp("^[A-Z0-9@.-_]+$", "i");
const TextOnlyNumber = new RegExp("^[,.0-9]+$", "i");
const TextAndNumber = new RegExp("^[ A-Z0-9]+$", "i");
const TextSpecialCharacter = new RegExp("^[ . , % $ # ñ Ñ A-Z0-9]+$", "i");
const TextPhone = new RegExp("^[0-9]+$", "i");
const Boolean = /^(true|false)$/i;
export const RegularExpressions = {
  TextWithSpace,
  TextEmail,
  TextOnlyNumber,
  TextAndNumber,
  TextPhone,
  TextSpecialCharacter,
  Boolean
};
